import type { Router } from 'vue-router'

/**
 * Ce que fait l'application quand le client HTTP signale « la session n'est
 * plus valable » (un 401 que le rafraîchissement n'a pas pu sauver).
 *
 * Deux cas, et le second est celui qui laissait l'écran figé :
 *
 *   * la session était ouverte (jeton révoqué, compte désactivé) : on l'oublie
 *     localement et on renvoie vers la connexion, avec `expired` pour que
 *     l'écran dise pourquoi ;
 *   * la session est DÉJÀ effacée — typiquement juste après « Se déconnecter »,
 *     quand la page encore affichée lance une dernière requête. L'ancienne
 *     version s'arrêtait là (« plus connecté, rien à faire ») : la page restait
 *     à l'écran, chaque requête répondait 401, et rien ne menait à la connexion.
 *     Une page qui exige une session renvoie donc vers la connexion, même ici.
 *
 * Isolé de `main.ts` pour être testé sans monter l'application.
 */
export function gererSessionPerdue(
  router: Router,
  auth: { readonly isAuthenticated: boolean; forgetLocally(): void },
): void {
  const etaitConnecte = auth.isAuthenticated
  if (etaitConnecte) auth.forgetLocally()

  const actuelle = router.currentRoute.value
  if (actuelle.name === 'login') return
  // Déjà déconnecté sur une page publique (documentation, invitation) : elle
  // n'a pas besoin de session, l'y laisser.
  if (!etaitConnecte && actuelle.meta.public) return

  void router.push({
    name: 'login',
    query: etaitConnecte ? { redirect: actuelle.fullPath, expired: '1' } : { redirect: actuelle.fullPath },
  })
}
